import { ActionReducer, createFeature, createReducer, on } from '@ngrx/store';
import { CONVERSATIONS_REPORT_ACTIONS, CONVERSATIONS_REPORT_API_ACTIONS } from './ace-conversations.actions';
import { ConversationModel, GroupedConversationRecord } from '../models/ace-conversations.model';

export const CONVERSATIONS_STATE_KEY = 'conversations';

export interface IConversationsState {
  data: ConversationModel[] | GroupedConversationRecord[];
  loading: boolean;
  error: Error | null;
  totalCount: number;
  activeViewLabel: string | null;
}

export const conversationsState: IConversationsState = {
  data: [],
  loading: false,
  error: null,
  totalCount: 0,
  activeViewLabel: null,
};

const reducer: ActionReducer<IConversationsState> = createReducer<IConversationsState>(
  conversationsState,
  on(CONVERSATIONS_REPORT_API_ACTIONS.get, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(CONVERSATIONS_REPORT_API_ACTIONS.success, (state, { conversations, totalCount }) => ({
    ...state,
    loading: false,
    data: conversations,
    totalCount,
  })),
  on(CONVERSATIONS_REPORT_API_ACTIONS.error, (state, { error }) => ({
    ...state,
    loading: false,
    totalCount: 0,
    error,
  })),
  on(CONVERSATIONS_REPORT_ACTIONS.setActiveView, (state, { viewName }) => ({
    ...state,
    activeViewLabel: viewName,
  })),
);

export const CONVERSATIONS_REDUCER = createFeature({
  name: CONVERSATIONS_STATE_KEY,
  reducer,
});
